function BrandLogo() {
  return (
    <div className="flex items-center gap-3">
      <div className="relative h-8 w-9 shrink-0">
        <span className="absolute left-1 top-2 h-3.5 w-3.5 rounded-full bg-[#ec5b93] opacity-90" />
        <span className="absolute left-3 top-1 h-4 w-4 rounded-full bg-[#6f3fc7] opacity-85" />
        <span className="absolute left-[18px] top-3.5 h-4 w-4 rounded-full bg-[#f3d25e] opacity-90" />
        <span className="absolute left-0 top-4 h-3 w-3 rounded-full bg-[#70b8f6] opacity-90" />
      </div>

      <p className="font-login text-[16px] font-bold tracking-[-0.02em] text-[#161616]">
        DP WORLD
      </p>
    </div>
  );
}

export default BrandLogo;
